import * as React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { body1, defaultFontStack } from "../../../../styles/typography/v2";

const Root = styled.ol(defaultFontStack, body1, {
  padding: 0,
  margin: 0,
  listStyle: "none",
});

function NumberList(props) {
  const { children, style } = props;
  return (
    <Root data-component-name="number-list" style={{ color: style?.textColor }}>
      {React.Children.map(children, (child, idx) => (
        <li>
          {idx + 1}. {child}
        </li>
      ))}
    </Root>
  );
}

NumberList.propTypes = {
  style: PropTypes.shape({
    textColor: PropTypes.string,
  }),
};

export default NumberList;
